/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */
import React from 'react' 
import {
    Label,
    Row,
    Column,
    ContentSection,
    Step,
    Loading,
} from 'trux'

export const StepSaving = (props) => {
    return (
        <Step name={props.name}>
            <ContentSection>
                <Column justifyContent="center" height="100%">
                    <Label
                        center
                        type={Label.Type.Heading3}
                        content={props.title}
                        maringBottom="8"
                    />
                    <Row center marginTop="8">
                        <Loading />
                    </Row>
                </Column>
            </ContentSection>
        </Step>
    )
}
